let ctx = null;

const audio = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

function tone(freq, dur, vol = 0.18, delay = 0) {
  try {
    const c = audio();
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "square";
    osc.frequency.value = freq;
    gain.gain.value = vol;
    osc.connect(gain);
    gain.connect(c.destination);
    const t0 = c.currentTime + delay;
    osc.start(t0);
    osc.stop(t0 + dur);
  } catch {}
}

export function beep() {
  tone(880, 0.12);
}

export function alarm() {
  [0, 0.28, 0.56, 0.84].forEach((d) => tone(1250, 0.24, 0.25, d));
}
